export default "__VITE_ASSET__H8atZWnX__"